import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DBProviders } from 'db/schema/providers';
import { RootState } from 'lib/store';

export interface DoctorSlice {
  pcp: string;
  selections: DBProviders[];
}

export const initialState: DoctorSlice = {
  pcp: '',
  selections: [],
};

const doctorSlice = createSlice({
  initialState,
  name: 'doctor',
  reducers: {
    setProviders: (state, action: PayloadAction<DBProviders[]>) => {
      return {
        ...state,
        selections: action.payload,
      };
    },
    setPrimaryCarePhysician: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        pcp: action.payload,
      };
    },
    addProvider: (state, action: PayloadAction<DBProviders>) => {
      return {
        ...state,
        selections: [...state.selections, action.payload],
      };
    },
    removeProvider: (state, action: PayloadAction<DBProviders>) => {
      return {
        ...state,
        selections: state.selections.filter((item) => {
          return item.id !== action.payload.id;
        }),
      };
    },
  },
});

const { actions, reducer } = doctorSlice;

export const {
  setProviders,
  setPrimaryCarePhysician,
  addProvider,
  removeProvider,
} = actions;

export default reducer;

export const selectProviders = (state: RootState) => state.doctor.selections;
